export default __webpack_public_path__ + "static/media/CrabPage2.dbc9c0ea.txt";